import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { BankAccountEditionFormWrapper } from 'src/Components/Forms/BankAccount/BankAccountEditionFormWrapper';

type BankAccountParams = {
  bankAccountId: string;
};

const EditBankAccountDrawer = () => {
  const { t } = useTranslation();
  const { bankAccountId } = useParams<BankAccountParams>();

  if (!bankAccountId) {
    return <Navigate to="/" replace />;
  }

  return (
    <AnimatedRoutedDrawer title={t('bankAccounts.editBankAccount', 'Modifier le compte')}>
      {({ onClose }) => (
        <BankAccountEditionFormWrapper
          onCreate={onClose}
          onCancel={onClose}
          bankAccountId={bankAccountId}
        />
      )}
    </AnimatedRoutedDrawer>
  );
};

export default EditBankAccountDrawer;
